import { resources } from "@constants/hardcoded-strings";
import { SelectFormGroup } from "@containers/common/select-form-group/select-form-group";
import { LabelWidthTypes } from "@enums/label-width-types";
import { LayoutTypes } from "@enums/layout-types";
import { MessagingTemplateTypes } from "@enums/messaging-template-types";
import { SelectOption } from "@iddataweb/idw-common-ui/types";
import { FormattedMessagingTemplate } from "@idw-types/data/messaging-template";
import { useMemo, useState } from "react";

type TemplateChooserProps = {
    templateOptions: Array<SelectOption>;
    selectedMessagingTemplates: Array<FormattedMessagingTemplate>;
    isDisabled: boolean;
    index: string;
    messagingTemplateType: MessagingTemplateTypes;
    templateRequestInProgress: boolean;
    validationWarning: React.ReactNode;
    setSelectedTemplate: (selectOption: SelectOption<string>, messagingTemplateType: MessagingTemplateTypes) => void;
}

export const TemplateChooser = (props: TemplateChooserProps) => {
    const {
        templateOptions,
        isDisabled,
        index,
        messagingTemplateType,
        templateRequestInProgress,
        selectedMessagingTemplates,
        validationWarning,
        setSelectedTemplate
    } = props;

    const [labelWidth] = useState(LabelWidthTypes.EXTRA_SMALL);
    const [layout] = useState(LayoutTypes.COLUMN);

    const handleTemplateChange = async (selectOption: SelectOption<string>) => {
        setSelectedTemplate(selectOption, messagingTemplateType);
    };

    const messagingTemplateResources = resources.pages.verificationServiceDetails.tabs.theming.subTabs.messaging;

    const selectedTemplate = useMemo(() => {
        const template = selectedMessagingTemplates.find(template => template.type === messagingTemplateType);
        if (template) {
            return template;
        }

        return null;
    }, [selectedMessagingTemplates, messagingTemplateType]);

    const selectedOption = useMemo(() => {
        if (selectedTemplate) {
            return {
                label: selectedTemplate.name,
                value: selectedTemplate.id
            }
        }

        return null;

    }, [selectedTemplate]);

    return (
        <>
            <SelectFormGroup
                controlId={`theming-messaging-template-select-input-${index}`}
                automationId={`theming-messaging-template-select-input-${index}`}
                label={messagingTemplateResources.inputs.selectTemplate.label(messagingTemplateType)}
                ariaLabel={messagingTemplateResources.inputs.selectTemplate.label(messagingTemplateType)}
                disabled={isDisabled || templateRequestInProgress}
                isClearable={true}
                isRequired={true}
                isSearchable={false}
                layout={layout}
                labelWidth={labelWidth}
                onChange={handleTemplateChange}
                options={templateOptions}
                selectedOption={selectedOption}
                isLoading={templateRequestInProgress}
                afterLabelTooltipText={messagingTemplateResources.inputs.selectTemplate.tooltip}
            />
            {validationWarning}
        </>
    );
}